export default __webpack_public_path__ + "static/media/tara-dust-tea.2d66040c.png";